var DECODER;

DECODER = new TextDecoder();

export default DECODER.decode.bind(DECODER);
